export default __webpack_public_path__ + "static/media/wapmonkeylogo.a7607de9.png";